import api from './api';

// Saldo de créditos compartilhado pela sessão: a moeda na sidebar, o selo de
// custo nos recursos e a tela de créditos leem daqui. Sem websocket — o saldo
// muda por ação da própria pessoa (comprar, gerar), então cada ação avisa o
// store via refreshCredits().

let state = { balance: 0, reserved: 0, isLow: false, features: [], quota: null, loaded: false };
let started = false;
let inFlight = null;
const listeners = new Set();

const notify = () => listeners.forEach(listener => listener(state));

const setState = value => {
    state = { ...state, ...value };
    notify();
};

export const refreshCredits = () => {
    if (inFlight) return inFlight;

    inFlight = api.get('/credit').then(res => {
        const resource = res.data.resource;

        setState({
            balance: resource.balance,
            reserved: resource.reserved,
            isLow: resource.is_low,
            threshold: resource.low_balance_threshold,
            features: resource.features ?? [],
            // Cota da pessoa (BDM-1058): o selo de custo mostra quanto ainda
            // resta do limite dela, que não é o mesmo que o saldo.
            quota: resource.quota ?? null,
            loaded: true
        });

        return state;
    }).catch(() => state).finally(() => {
        inFlight = null;
    });

    return inFlight;
}

export const getCredits = () => state;

/** Custo de um recurso, já no formato que a tela mostra. */
export const getFeatureCost = key => {
    const feature = state.features.find(item => item.key === key);

    if (!feature) return null;

    const metered = feature.pricing_mode === 'metered';

    return {
        ...feature,
        metered,
        // No modo medido o número que importa é o teto: é o que reservamos
        // antes de rodar e o que precisa estar em caixa.
        cost: metered ? (feature.max_credits ?? feature.cost_credits) : feature.cost_credits,
        min: feature.min_credits ?? 0
    };
}

export const subscribeCredits = listener => {
    if (!started) {
        started = true;
        refreshCredits();
    }

    listeners.add(listener);
    listener(state);

    return () => listeners.delete(listener);
}

export const resetCredits = () => {
    started = false;
    inFlight = null;
    setState({ balance: 0, reserved: 0, isLow: false, features: [], quota: null, loaded: false });
}
